import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../components/ui/card";
import { Label } from "../components/ui/label";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

export const PerPersonCard = ({
  t,
  costPerPerson,
  onCostPerPersonChange,
  customPerPersonItems,
  onAddItem,
  onRemoveItem,
  onItemChange,
  formatMoneyValue,
}) => (
  <Card className="relative overflow-visible">
    <CardHeader>
      <CardTitle>{t("perPerson.cardTitle")}</CardTitle>
      <CardDescription>{t("perPerson.cardDescription")}</CardDescription>
    </CardHeader>
    <CardContent>
      <div className="space-y-4">
        <div className="space-y-1">
          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-3">
            <Label className="sm:w-1/2">{t("perPerson.baseLabel")}</Label>
            <Input
              className="sm:flex-1"
              type="text"
              inputMode="decimal"
              value={formatMoneyValue(costPerPerson)}
              onChange={(e) => onCostPerPersonChange(e.target.value)}
              placeholder={t("perPerson.basePlaceholder")}
            />
          </div>
        </div>

        <div className="space-y-2">
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2 text-xs text-slate-600">
              <Label>{t("perPerson.customLabel")}</Label>
            </div>

            {/* Add button with tooltip */}
            <div className="relative inline-flex group">
              <Button
                variant="outline"
                size="sm"
                type="button"
                onClick={onAddItem}
              >
                {t("perPerson.addButton")}
              </Button>
              <div
                className="pointer-events-none absolute right-0 top-full mt-1 w-56 rounded-md border border-slate-200
  bg-white px-3 py-2 text-[11px] text-slate-600 shadow-md opacity-0 group-hover:opacity-100 transition-opacity z-20"
              >
                {t("perPerson.addTooltip")}
              </div>
            </div>
          </div>
          <div className="space-y-2">
            {customPerPersonItems.map((item, index) => (
              <div
                key={index}
                className="grid gap-2 sm:grid-cols-[minmax(0,2fr)_minmax(0,1fr)_auto]"
              >
                <input
                  className="h-9 rounded-md border border-input bg-white px-3 py-1 text-sm outline-none focus-visible:ring-2 focus-visible:ring-rose-400"
                  placeholder={t("perPerson.itemPlaceholder")}
                  value={item.label}
                  onChange={(e) =>
                    onItemChange(index, "label", e.target.value)
                  }
                />
                <Input
                  type="text"
                  inputMode="decimal"
                  placeholder={t("perPerson.amountPlaceholder")}
                  value={formatMoneyValue(item.amount)}
                  onChange={(e) =>
                    onItemChange(index, "amount", e.target.value)
                  }
                />
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  onClick={() => onRemoveItem(index)}
                >
                  {t("perPerson.removeButton")}
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </CardContent>
  </Card>
);
